interface CognitoIdToken {
  idToken: string;
  expires: number;
}

let cognitoIdToken: CognitoIdToken | undefined;

export const setToken = (idToken: string, expires: number): void => {
  if (!idToken || !expires) {
    throw new Error('idToken and expires are required parameters');
  }

  cognitoIdToken = {
    idToken,
    expires,
  };
};

export const authHeaders = () => {
  const baseHeaders = {
    Accept: 'application/graphql-response+json; charset=utf-8, application/json; charset=utf-8',
    'Content-Type': 'application/json',
  };
  if (!cognitoIdToken) {
    return baseHeaders;
  }

  return {
    ...baseHeaders,
    Authorization: `Bearer ${cognitoIdToken.idToken}`,
  };
};
